/** Salesforce (and Walter) ids are 15 or 18 alphanumeric characters. */
const SF_ID_PATTERN = /^[a-zA-Z0-9]{15,18}$/;

/** Known CRM object prefixes we resolve via /sf/:sfId. Keep in sync with sf_id_redirect.py. */
const SF_ID_KNOWN_PREFIX_PATTERN = /^(001|003|00Q|006|00T|500)[a-zA-Z0-9]{12,15}$/;

/**
 * Return true when *value* looks like a Salesforce id suitable for the
 * search-bar Enter shortcut (known object prefixes only, to limit false positives).
 */
export function looksLikeSalesforceId(value: string | null | undefined): boolean {
    if (!value) return false;
    return SF_ID_KNOWN_PREFIX_PATTERN.test(value.trim());
}

/** Loose 15–18 alphanumeric check (used where prefix is unknown). */
export function looksLikeLooseSalesforceId(value: string | null | undefined): boolean {
    if (!value) return false;
    return SF_ID_PATTERN.test(value.trim());
}
